module.exports = __webpack_public_path__ + "static/img/200209.f2b87f21.png";